module.exports = __webpack_public_path__ + "img/about-2.50e77a44.jpg";